import { CacheProvider } from '@emotion/react'

export default CacheProvider
